import StoreProfile from './StoreProfile';
import React from 'react';
export default StoreProfile;